<template>
  <v-dialog
    v-if="show"
    :value="show"
    max-width="80%"
    height="100%"
    persistent
    :fullscreen="fullscreen"
    @keydown.esc="done"
    ><v-card>
      <v-card-title>
        <span class="headline">
          {{ $t("extTrainings.employees.add.title") }} {{ extTraining.id }} -
          {{ extTraining.name }} -
          {{ $options.filters.date(extTraining.dateTimeOfOccurrence) }}
        </span>
        <v-spacer />
        <v-btn icon @click="fullscreen = !fullscreen"
          ><v-icon>{{
            fullscreen ? "fullscreen_exit" : "fullscreen"
          }}</v-icon></v-btn
        >
        <v-btn icon @click="done"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <ext-training-employees-table
        :employees="filteredEmployees"
        :tags="tags"
        :loading="loading"
        :tagCategories="tagCategories"
        :selectedEmployees="selectedEmployees"
        @selectedChange="handleEmployeesSelected"
        @filtersChange="handleFiltersChange"
        :showSelect="true"
        :showLastTraining="true"
        :selectedHeader="$t('extTrainings.employees.selected')"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="done">
          {{ $t("dialog.cancel") }}
        </v-btn>
        <v-btn color="primary" text :loading="loading" @click="changeEmployees">
          {{ $t("dialog.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

import EmployeesForExtTrainingQuery from "@/graphql/queries/EmployeesForExtTraining.gql";
import TagCategoriesQuery from "@/graphql/TagCategories.gql";
import ExtTrainingEmployeesTable from "@/components/extTraining/ExtTrainingEmployeesTable.vue";

import ChangeExtTrainingEmployees from "@/graphql/mutation/extTraining/ChangeExtTrainingEmployees.gql";
import { createTagCategories, createEmployeesSearch } from "@/utils/common.js";

export default {
  props: ["show", "extTraining", "tags"],
  components: {
    ExtTrainingEmployeesTable,
  },
  data() {
    return {
      selectedEmployees: [],
      loading: false,
      fullscreen: false,
      filters: [],
    };
  },
  computed: {
    ...mapGetters(["role"]),
    filteredEmployees() {
      if (this.employees && !this.employees.length) return [];
      return this.filters.length == 0
        ? this.employees
        : this.employees.filter((e) => {
            const filter = e.tags.some((t) =>
              this.filters.some(
                (ft) => ft.name == t.name && ft.category == t.category
              )
            );
            return filter;
          }) || [];
    },
  },
  mounted() {},
  watch: {},
  methods: {
    changeEmployees() {
      this.loading = true;
      const id = this.extTraining.id;
      const eIn = this.selectedEmployees.map((e) => ({
        externalTrainingId: id,
        employeeId: e.id,
        participated: !!e.participated,
      }));
      this.$apollo
        .mutate({
          mutation: ChangeExtTrainingEmployees,
          variables: {
            id,
            eIn,
          },
        })
        .then(() => {
          this.done();
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            color: "error",
            text: `Failed to add or remove employees in external training ID ${id} with error: ${err}`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleFiltersChange(fc) {
      if (fc) {
        this.filters = fc;
      }
    },
    handleEmployeesSelected(es) {
      if (es) {
        this.selectedEmployees = es;
      }
    },
    done() {
      this.$emit("done");
    },
  },

  apollo: {
    tagCategories: {
      query: TagCategoriesQuery,
    },
    employees: {
      query: EmployeesForExtTrainingQuery,
      variables() {
        return {
          queryAll: true,
          queryAllShifts: true,
        };
      },
      fetchPolicy: "cache-and-network",
      update(data) {
        const extTrainingEmployeeById = new Set();
        for (const ete of this.extTraining.employees) {
          extTrainingEmployeeById.add(ete.id);
        }

        const items =
          data.employees &&
          data.employees.map((e) => {
            if (extTrainingEmployeeById.has(e.id)) {
              this.selectedEmployees.push(e);
            }
            const upcomingExtTrainingPerCategory =
              e.upcomingExtTrainingPerCategory.find(
                (y) => y.categoryId == this.extTraining.categoryId
              ) || null;
            const lastExtTrainingPerCategory =
              e.lastExtTrainingPerCategory.find(
                (y) => y.categoryId == this.extTraining.categoryId
              ) || null;
            e.modes = [];
            return {
              ...e,
              isSelected: extTrainingEmployeeById.has(e.id),
              upcomingExtTrainingPerCategory,
              lastExtTrainingPerCategory,
              search: createEmployeesSearch(e),
              ...createTagCategories(this.tagCategories, e.tags),
            };
          });

        return items.sort((a, b) => b.isSelected - a.isSelected);
      },
      skip() {
        return !this.tagCategories;
      },
    },
  },
};
</script>
